/**
 * @file useSeoAudit.ts
 * @description «Проверка сайта» (phase19.16, партия Р3в, v0.19.64; SB132;
 * db-design-r3v §6.2): результат из памяти API (10 мин) при открытии,
 * «Проверить снова» — пересчёт. Ответ не хранится в кабинете дольше
 * страницы: следующий вход спросит заново.
 */

import { useCallback, useEffect, useState } from "react";

import { shopSeo, type SiteSeoAuditDto } from "../../lib/api-site-seo";

export interface SeoAuditApi {
  audit: SiteSeoAuditDto | null;
  loading: boolean;
  failed: boolean;
  run: (refresh?: boolean) => Promise<void>;
}

export function useSeoAudit(enabled = true): SeoAuditApi {
  const [audit, setAudit] = useState<SiteSeoAuditDto | null>(null);
  const [loading, setLoading] = useState(false);
  const [failed, setFailed] = useState(false);

  const run = useCallback(
    async (refresh = false) => {
      if (!enabled) return;
      setLoading(true);
      setFailed(false);
      try {
        setAudit(await shopSeo.audit(refresh));
      } catch {
        setFailed(true);
      } finally {
        setLoading(false);
      }
    },
    [enabled],
  );

  useEffect(() => {
    void run(false);
  }, [run]);

  return { audit, loading, failed, run };
}
